/**
 * useAuthMetadata returns a builder that produces the `Authorization: Bearer`
 * Headers gRPC-web calls expect. Capturing the access-token ref here (during
 * setup) and reading `.value` lazily at request time keeps a single source of
 * truth for the auth header instead of re-declaring the same snippet in every
 * component that makes an authenticated RPC.
 */
export default function useAuthMetadata(): () => Headers {
  const accessToken = useAccessToken();

  return () => {
    const metadata = new Headers();
    metadata.set('authorization', `Bearer ${accessToken.value}`);
    return metadata;
  };
}
